import { format } from 'date-fns';

// Plano disponível: ativo e com dueDate (yyyy-MM-dd) ainda não vencido
export const isPlanAvailable = (plan, { requireActive = false } = {}) => {
  if (requireActive ? plan.status !== true : plan.status === false) return false;
  if (!plan.dueDate) return true;
  return String(plan.dueDate).slice(0, 10) >= format(new Date(), 'yyyy-MM-dd');
};
